import React from "react";
import styles from "./IconButton.module.css";

interface Props {
    children: any;
}
export const IconButton = ({children}: Props) => {
    return <div className={styles['icon-button']}>{children}</div>
}